import { Action } from "redux";

export const AUTH_LOGOUT = "AUTH_LOGOUT";

export interface AuthLogoutAction extends Action {
  type: "AUTH_LOGOUT";
}

export const logoutAction = (): AuthLogoutAction => ({
  type: AUTH_LOGOUT,
});
